import { render } from "./Switch.vue?vue&type=template&id=d82562d0&scoped=true"
import script from "./Switch.vue?vue&type=script&lang=js"
export * from "./Switch.vue?vue&type=script&lang=js"

import "./Switch.vue?vue&type=style&index=0&id=d82562d0&lang=scss&scoped=true"

import exportComponent from "/Applications/dev/FLEXX_FREIGHT/flexx-freight-stats/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d82562d0"]])

export default __exports__